<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 mt-2">
      <b-tabs>
        <b-tab
          :title="`${this.$t('menu.settings.accountData.customRules')}`"
          active
        >
          <idx-card
            :title="`${this.$t('menu.settings.accountData.customRules')}`"
          >
            <div class="row">
              <div class="col-6">
                <div class="input-area">
                  <button v-b-modal.modal-add class="btn btn-primary">
                    Nova regra de operação
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <b-table striped :items="items" :fields="fields">
                  <template v-slot:cell(active)="row">
                    <div class="custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="`is-active-rule-${row.item._id}`"
                        v-model="row.item.active"
                        @change="disableRule(row.item._id, row.item.active)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`is-active-rule-${row.item._id}`"
                      ></label>
                    </div>
                  </template>

                  <template v-slot:cell(action)="row">
                    <div class="text-center">
                      <button
                        :id="`rule-pen-${row.item._id}`"
                        @click="editRule(row.item)"
                        class="btn btn-outline-primary"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" />
                      </button>
                      <button
                        :id="`rule-trash-${row.item._id}`"
                        class="btn btn-outline-danger"
                        @click="deleteRule(row.item._id)"
                        style="display: inline;"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </idx-card>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal
      id="modal-add"
      title="Adicionar regra de tratativa"
      size="lg"
      ok-only
      scrollable
      :hide-footer="true"
    >
      <Add />
    </b-modal>

    <b-modal
      id="modal-edit"
      title="Editar regra de tratativa"
      size="lg"
      ok-only
      scrollable
      :hide-footer="true"
    >
      <Edit :rule="rule" />
    </b-modal>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import swal from 'sweetalert';
import api from '../../../services/api';
import Add from './add';
import Edit from './edit';

export default {
  components: { IdxCard, Add, Edit },

  data: () => ({
    loading: false,
    userAuth: null,
    fields: [],
    items: [],
    newRule: {
      name: null,
      displayOrder: null,
      schedulingOrder: null,
      timeRule: null,
      ruleOrder: null,
      actions: null,
    },
    rule: null,
  }),

  methods: {
    async deleteRule(id) {
      swal({
        title: 'Atenção!',
        text: 'Quer mesmo excluir esta regra?',
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.accountData.subCategory.cancelDescription'),
          this.$t('menu.settings.accountData.subCategory.deleteDescription'),
        ],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            await api.delete(`/treatment/delete-rule/${id}`, {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            });
            swal('Sucesso', 'Regra removida com sucesso', 'success');
            await this.getTreatmentRules();
          } catch (error) {
            window.console.log(error);
          }
        }
      });
    },

    editRule(item) {
      this.rule = item;
      setTimeout(() => {
        this.$bvModal.show('modal-edit');
      }, 100);
    },

    async disableRule(id, active) {
      try {
        await api.patch(
          `/treatment/update-rule/${id}`,
          {
            active,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        swal('Sucesso', 'Regra atualizada com sucesso', 'success');

        if (active) {
          const anothers = this.items.filter((item) => item._id !== id);

          const promises = anothers.map(async (rule) => {
            await api.patch(
              `/treatment/update-rule/${rule._id}`,
              {
                active: false,
              },
              {
                headers: {
                  'x-access-token': this.userAuth.token,
                },
              },
            );
          });

          await Promise.all(promises);
        }

        await this.getTreatmentRules();
      } catch (error) {
        window.console.log(error);
      }
    },

    async getTreatmentRules() {
      try {
        const response = await api.get(`/treatment/list-rules`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.items = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getTreatmentRules();

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'modal-add') {
        this.getTreatmentRules();
      }
    });
  },
  created() {
    this.fields = [
      {
        key: 'active',
        label: 'Ativo',
        sortable: true,
      },
      {
        key: 'name',
        label: 'Nome da regra',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Editar',
        class: 'text-center',
      },
    ];
  },
};
</script>

<style scoped>
.input-area {
  display: flex;
  flex-direction: row;
}
</style>

<style>
.action-list-item {
  padding: 8px;
  border-bottom: solid 1px #cccccc;
  background: #ffffff;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatments-rules/index.vue